// components/model/SeriesFilter.jsx
import React from "react";

const SeriesFilter = ({
  seriesList,
  selectedSeriesId,
  onSeriesChange,
  isDarkMode,
  productCount,
}) => {
  if (!seriesList || seriesList.length === 0) return null;

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-3">
        <h3
          className={`text-xs font-medium md:text-sm ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}
        >
          Select Series
        </h3>
      </div>
      <div className="flex flex-wrap gap-1.5 md:gap-2">
        <button
          onClick={() => onSeriesChange("")}
          className={`px-2.5 py-1 text-[10px] font-medium rounded-full whitespace-nowrap transition-colors md:px-3 md:py-1.5 md:text-xs ${
            selectedSeriesId === ""
              ? isDarkMode
                ? "bg-emerald-600 text-white"
                : "bg-emerald-500 text-white"
              : isDarkMode
                ? "bg-gray-800 text-gray-300 hover:bg-gray-700"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
          }`}
        >
          All Series
        </button>
        {seriesList.map((item) => (
          <button
            key={item.id}
            onClick={() => onSeriesChange(item.id.toString())}
            className={`px-2.5 py-1 text-[10px] font-medium rounded-full whitespace-nowrap transition-colors md:px-3 md:py-1.5 md:text-xs ${
              selectedSeriesId === item.id.toString()
                ? isDarkMode
                  ? "bg-emerald-600 text-white"
                  : "bg-emerald-500 text-white"
                : isDarkMode
                  ? "bg-gray-800 text-gray-300 hover:bg-gray-700"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
          >
            {item.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SeriesFilter;
